import React, { useContext } from 'react';

import ContributeContext from '../context';

const ContributeHeader = () => {
    const { campaign } = useContext(ContributeContext);

    return (
        <div className="text-center py-6 rounded border border-gray-20 md:border-0">
            <p className="text-gray-40 text-14">You are contributing to</p>
            <h1 className="font-display uppercase text-green-50 text-36 font-regular leading-tight">
                {campaign.name}
            </h1>
        </div>
    );
};

export default ContributeHeader;
